export default __webpack_public_path__ + "static/integration-glow-cropped-6548b4cf6bd074a0cb6cd6566739838b.webp";